import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { selectors } from './init.js';

const hasTilesLayout = (container) => container.classList.contains('swiper');

export const initSlider = () => {
	document.querySelectorAll(`${selectors.locationSlider}`).forEach((container) => {
		const category = container.getAttribute('data-cat');
		const parameters = {
			modules: [Navigation, Pagination],
			loop: true,
			slidesPerView: hasTilesLayout(container) ? 1.25 : 1,
			spaceBetween: hasTilesLayout(container) ? 32 : 0,
			navigation: {
				nextEl: container.querySelector(selectors.sliderBtnNext),
				prevEl: container.querySelector(selectors.sliderBtnPrev),
			},
			pagination: {
				el: `.swiper-pagination-${category}`,
				type: 'bullets',
				clickable: true,
			},
		};

		if (hasTilesLayout(container)) {
			parameters.pagination.dynamicBullets = true;
			parameters.breakpoints = {
				1000: {
					pagination: {
						dynamicBullets: false,
					},
					slidesPerView: 3.25,
					slidesPerGroup: 3,
				},
				1200: {
					pagination: {
						dynamicBullets: false,
					},
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
			};
		}

		new Swiper(container, parameters);
	});
};
